import { render, staticRenderFns } from "./PatientDetailPage.vue?vue&type=template&id=5bf0c5a6"
import script from "./PatientDetailPage.vue?vue&type=script&lang=js"
export * from "./PatientDetailPage.vue?vue&type=script&lang=js"
import style0 from "./PatientDetailPage.vue?vue&type=style&index=0&id=5bf0c5a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports